import type { Location } from 'react-router-dom'

/**
 * Роут-модалы (тарифы, вход): переход изнутри сайта кладёт страницу, поверх которой открыто окно, в
 * location.state.backgroundLocation — App рисует под окном её. Прямой заход и F5 состояния не имеют → полная страница.
 */
export function backgroundOf(location: Location): Location | null {
	return (location.state as { backgroundLocation?: Location } | null)?.backgroundLocation ?? null
}

/** Окна входа, которые App показывает поверх страницы, если переход пришёл изнутри сайта (useOpenAuth). */
export const AUTH_MODAL_PATHS = ['/login', '/register', '/verify-pending', '/forgot-password']

export function isAuthModalPath(pathname: string): boolean {
	return AUTH_MODAL_PATHS.includes(pathname)
}
